import { GeofenceInfo } from '../model/geofence-info';
import { LocationBuilder } from './location-builder';
export class GeofenceInfoBuilder {
    static buildGeofenceInfo(data) {
        let geofenceInfo = new GeofenceInfo();
        if (!data) {
            return null;
        }
        geofenceInfo.id = data.id;
        geofenceInfo.idProduct = data.id_product;
        geofenceInfo.idTerminal = data.id_terminal;
        geofenceInfo.location = LocationBuilder.buildLocation(data);
        geofenceInfo.mode = data.mode;
        geofenceInfo.name = data.name;
        geofenceInfo.prediction = data.prediction;
        geofenceInfo.radius = data.radius;
        return geofenceInfo;
    }
}
//# sourceMappingURL=geofence-info-builder.js.map